module.exports = __webpack_public_path__ + "a33b5cdb09b25a15fb2ffe844d9580e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/hanko-saiteishutsu.png
// module id = 2105
// module chunks = 4